import Helper from '../Models/Helper';
import Scripture from '../Models/Scripture';
import Trigger from '../Models/Trigger';
import {writable} from 'svelte/store';

/* Dit initial object staat in de LocalStorage.
Nieuw toegevoegde properties zijn voor oude bezoekers niet besachikbaar.
Nieuwe properties moeten hierdoor dus altijd een falsy default hebben. */

const initial = {
	authentication: {active: false, token: ''},
	user: {name: '', initials: ''},
	cookie: {status: 'ask'},
	menu: {active: false, block_bar: false, busy: false, timeout: 0},
	bookmark: {chapter: '', name: ''},
	router: {url: ''},
	theme: {code: 'light', dark: false, fixed: false},
	tip: {favorite: false, audio: false},
	read: {size: {offset: 0}}
};

const initial_json = JSON.stringify(initial);

let state; try {
	const json = window.localStorage.getItem('session');
	if (json) {
		state = JSON.parse(json);
		state = Object.assign(initial, state);
	}

	if (!Helper.is(state))
		state = initial;
}
catch (error)
	{ state = initial; }

const session = writable(state);

/* Events */

session.subscribe(state => {
	try {
		const json = JSON.stringify(state);
		window.localStorage.setItem('session', json);
	}
	catch (error) { }
});

/* Shared */

session.updateCookie = status => {
	state.cookie.status = status;
	session.set(state);
	Trigger.event('cookie', state.cookie);
};

session.updateBookmark = async chapter => {
	const info = chapter ? await Scripture.infoByCode(chapter) : {};
	state.bookmark.chapter = chapter || '';
	state.bookmark.name = chapter ? info.chapter.name : '';
	session.set(state);
	Trigger.event('bookmark', state.bookmark);
};

session.reset = () => {
	state = JSON.parse(initial_json);
	session.set(state);
	window.location.reload();
};

/* Theme */

session.updateTheme = light => {
	state.theme.dark = !light;
	state.theme.code = light ? 'light' : 'dark';
	Trigger.event('theme', state.theme);
	session.set(state);
};

session.toggleTheme = () => {
	state.theme.fixed = true;
	session.updateTheme(state.theme.dark);
};

/* Menu */

session.updateMenu = (active, block_bar) => {
	state.menu.busy = true;
	state.menu.active = active;
	state.menu.block_bar = !!block_bar;

	clearTimeout(state.menu.timeout);
	state.menu.timeout = setTimeout(() => {
		state.menu.busy = false;
		Trigger.event('menu', state.menu);
		session.set(state);
	}, 1000);

	Trigger.event('menu', state.menu);
	session.set(state);
};

session.toggleMenu = block_bar => {
	const active = !state.menu.active;
	session.updateMenu(active, block_bar);
};

/* Session */

session.updateAuthentication = token => {
	state.authentication.active = !!token;
	state.authentication.token = token;
	Trigger.event('authentication', state.authentication);
	session.set(state);
}

session.updateUser = name => {
	state.user.name = name;
	state.user.initials = name[0];
	Trigger.event('user', state.user);
	session.set(state);
}

/* Network */

session.updateRouter = url => {
	state.router.url = url;
	Trigger.event('router', state.router);
	session.set(state);
};

export default session;